import React from "react"
import * as Icon from "react-feather"
import { store } from "../redux/storeConfig/store"
import { logoutUserAction } from '../redux/actions/auth/loginActions'

const apkVersion = '0-0-7';

const navigationConfig = [
  {
    id: "home",
    title: "Home",
    type: "item",
    icon: <Icon.Home size={20} />,
    permissions: ["admin", "checker"],
    navLink: "/"
  },
  {
    id: "assessments",
    title: "Passages",
    type: "item",
    icon: <Icon.BookOpen size={20} />,
    permissions: ["admin"],
    navLink: "/passages"
  },
  {
    id: "schools",
    title: "Schools",
    type: "item",
    icon: <Icon.Database size={20} />,
    permissions: ["admin"],
    navLink: "/schools"
  },
  {
    id: "content",
    title: "Content",
    type: "item",
    icon: <Icon.FileText size={20} />,
    permissions: ["admin"],
    navLink: "/content"
  },
  {
    id: "grades",
    title: "Grades",
    type: "item",
    icon: <Icon.TrendingUp size={20} />,
    permissions: ["admin"],
    navLink: "/grades"
  },
  {
    id: "classes",
    title: "Classes",
    type: "item",
    icon: <Icon.Grid size={20} />,
    permissions: ["admin"],
    navLink: "/classes"
  },
  {
    id: "users",
    title: "Users",
    type: "item",
    icon: <Icon.User size={20} />,
    permissions: ["admin"],
    navLink: "/users"
  },
  {
    id: "students",
    title: "Students",
    type: "item",
    icon: <Icon.Users size={20} />,
    permissions: ["admin"],
    navLink: "/students"
  },
  {
    id: "exams",
    title: "Exams",
    type: "item",
    icon: <Icon.FileText size={20} />,
    permissions: ["admin", "checker"],
    navLink: "/exams"
  },
  {
    id: "notifications",
    title: "Notifications",
    type: "item",
    icon: <Icon.Bell size={20} />,
    permissions: ["admin"],
    navLink: "/notifications"
  },
  {
    id: "csvdownload",
    title: "Csv download",
    type: "item",
    icon: <Icon.Download size={20} />,
    permissions: ["admin"],
    navLink: "/csv-download"
  },
  {
    id: "books",
    title: "Books",
    type: "item",
    icon: <Icon.Book size={20} />,
    permissions: ["admin"],
    navLink: "/all-books"
  },
  {
    id: "roles",
    title: "Roles",
    type: "item",
    icon: <Icon.Book size={20} />,
    permissions: ["admin"],
    navLink: "/roles"
  },
  {
    id: "testing",
    title: "Test cases",
    type: "item",
    icon: <Icon.Activity size={20} />,
    permissions: ["admin"],
    navLink: "/testing"
  },
  {
    id: "apk",
    title: `Last .apk (${apkVersion})`,
    type: "external-link",
    icon: <Icon.DownloadCloud size={20} />,
    permissions: ["admin", "checker"],
    navLink: `http://teeread.com/apk_builds/${apkVersion}.apk`
  },
  {
    id: "logout",
    title: "Logout",
    type: "item",
    icon: <Icon.Power size={20} />,
    permissions: ["admin", "checker"],
    navLink: "/login",
    action: () => {
      store.dispatch(logoutUserAction());
      localStorage.removeItem('user-tr');
    }
  }
]

export default navigationConfig
